import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function subscribe() {

	// Make it with gsap and scrolltrigger when I come to the block it is revealad from top
	const subscribe = document.querySelector('.subscribe');


	if (subscribe) {
		gsap.from(subscribe, {
			yPercent: -20,
			scrollTrigger: {
				trigger: subscribe,
				start: 'top center',
				end: 'center center',
				scrub: 1,
				toggleActions: 'play reverse play reverse'
			}
		});
	}

}